export interface INoteEditRequest  {
    ID: number;
    Note: string;
    Sticky: boolean;
    RequestReview: boolean;
    AdminID: number;
}

export class NoteEditRequest implements INoteEditRequest {

    ID: number;
    Note: string;
    Sticky: boolean;
    RequestReview: boolean;
    AdminID: number;

}
